import moment from 'moment';
import {
  GET_HISTOGRAM_REQUEST,
  GET_HISTOGRAM_SUCCESS,
  GET_HISTOGRAM_FAILURE,
  GET_HISTOGRAM_CACHED,
  SET_USER_IMPERSONATION,
  RELOAD_FILTERS,
} from '../action/actionTypes';

const initialState = {
  payload: {},
  error: '',
  isWaiting: false,
};

export default function histogram(state = initialState, action) {
  switch (action.type) {
    case GET_HISTOGRAM_REQUEST:
      return {
        ...state,
        isWaiting: true,
        error: initialState.error,
      };
    case GET_HISTOGRAM_SUCCESS:
      return {
        ...state,
        payload: {
          ...state.payload,
          [action.payload.key]: { ...action.payload, lastRefresh: moment() },
        },
        isWaiting: false,
        error: initialState.error,
      };
    case GET_HISTOGRAM_FAILURE:
      return {
        ...state,
        error: action.error,
        isWaiting: false,
      };
    case GET_HISTOGRAM_CACHED:
      return {
        ...state,
        error: initialState.error,
        isWaiting: false,
      };
    case SET_USER_IMPERSONATION:
      return { ...initialState };
    case RELOAD_FILTERS:
      return initialState;
    default:
      return state;
  }
}
